
import React from 'react';
import CommonButton from './CommonButton';
import AnnouncementImg from '../../assets/images/Providers/Announcement.webp'

const MapSectionTwo = () => {
  return (
    <>
    <section id='website-responsive' className="container-fluid px-md-5 px-3 py-5 mt-md-5 mt-4" style={{backgroundColor:"#fff4d4"}}>
      <div className="row justify-content-evenly gy-4 align-items-center">
        <div className="col-12 col-sm-7 col-md-6 ">
          <div className='fs-ss-22 text-ss-primary font-ss-pri fw-ss-400'>
          Our Location
          </div>
          <div className='fs-ss-35 text-black font-ss-pri fw-ss-700 py-2'>
          Partnership Based On Trust
          </div>
          <div className='fs-ss-16 fw-ss-400 lh-30 pb-4'>
          We help you in your goal to ensure that your child’s health never falls below the peak condition. So, your expectations may be high, but we always work hard to reach further. If you seek attentive and accessible care for your child, then our pediatrics clinic is the place for you!
          </div>
          <a className='text-decoration-none' target='_blank' href="https://maps.app.goo.gl/PkNu74KqRbPHRTfu9">
          <CommonButton
      ClsName='btn btn-light bg-ss-primary btn-ss-primary-secondary rounded-3 border-0  fs-ss-17 px-4 py-2 fw-ss-500 d-block mb-3'
      Title="View on Google Map"/>
      </a>
            </div>
            <div className="col-9 col-sm-4 col-md-5 text-center ">
            <img className='w-50 d-none d-lg-inline' src={AnnouncementImg} alt="AnnouncementImg" />
            <img className='w-75 d-inline d-lg-none' src={AnnouncementImg} alt="AnnouncementImg" />
        </div>
      </div>
    </section>
    </>


  );
}

export default MapSectionTwo;
